<div class="list-wrapper">
    <p>{{ 'instructionToOpenSingle' | translate }}</p>
    <div class="list-table-wrapper">
        <table>
            <thead>
                <tr>
                    <td>{{ 'companyName' | translate }}</td>
                    <td>{{ 'city' | translate }}</td>
                    <td>{{ 'accountNumber' | translate }}</td>
                    <td>{{ 'GoToAccount' | translate }}</td>
                    <td>{{ 'ViewContacts' | translate }}</td>
                </tr>
            </thead>
            <tbody>
                @for (consumer of consumers; track consumer) {
                <tr>
                    <td>
                        <a (click)="generateQuickLink(consumer.Id)" href="javascript:void(0)">{{ consumer.CompanyName }}</a>
                    </td>
                    <td>{{consumer.Addresses?.[0]?.City}}</td>
                    <td>{{ consumer.Id }}</td>
                    <td>
                        <span class="justify-center">
                            <por-base-button [class]="'transparent bg-gray'" featureName="view-contacts-button" (onclick)="generateQuickLink(consumer.Id)">
                                <mat-icon>forward</mat-icon>
                            </por-base-button>
                        </span>
                    </td>
                    <td>
                        <span class="justify-center">
                            <por-base-button [class]="'transparent bg-gray'" featureName="view-contacts-button" (onclick)="getViewContacts(consumer)"><mat-icon>open_in_new</mat-icon></por-base-button>
                        </span>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    @if (!noMoreRecord) {
    <por-base-button (onclick)="loadMore.emit()" class="theme-button apply-btn" [featureName]="'admin-save-button-data'">
        {{ 'Load More' | translate }}
    </por-base-button>
    }
</div>
